import { LOW_STOCK_THRESHOLD } from '@kon/shared';
import styles from './StockBadge.module.css';

export function StockBadge({ stock }: { stock: number }) {
  if (stock <= 0) {
    return (
      <span className={`${styles.badge} ${styles.out}`}>
        <span className={styles.dot} aria-hidden="true" />
        Out of stock
      </span>
    );
  }
  if (stock <= LOW_STOCK_THRESHOLD) {
    return (
      <span className={`${styles.badge} ${styles.low}`}>
        <span className={styles.dot} aria-hidden="true" />
        Low stock · {stock} left
      </span>
    );
  }
  return (
    <span className={`${styles.badge} ${styles.in}`}>
      <span className={styles.dot} aria-hidden="true" />
      In stock
    </span>
  );
}
